import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  filter: grayscale(${(props) => props.theme.gray});
  position: relative;
`;

export const Main = styled.div``;

export const TemporarySwitchToChangeLayout = styled.div`
  padding-left: 25rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    display: none;
  }
`;
